import React, { useEffect, useState, useRef } from "react";
import { PiUserGearLight, PiUserPlusLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { API_URL, NODE_ENV } from "../../utils/constants";
import commonActions from "../../redux/common/actions";
import { io } from "socket.io-client";
import { useDispatch, useSelector } from "react-redux";
import GreenButton from "../../common/button/greenButton";
import xlsx from "json-as-xlsx";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import xlsxpng from "../../assets/images/uploads/xlsx.png";
import { PiXBold } from "react-icons/pi";
import { IoCloudUploadOutline } from "react-icons/io5";
import {
  Box,
  Card,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Menu,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  LinearProgress,
  Chip,
  Stack,
  Divider,
  InputLabel,
  Alert,
} from "@mui/material";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { cssProperties } from "../../utils/commonCssProperties";
import generateAdmitcardActions from "../../redux/admitcardgeneration/action";
import singleAdmitcardActions from "../../redux/singleAdmitcard/action";
import masterActions from "../../redux/master/actions";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";

export default function Index() {
  const dispatch = useDispatch();
  const socketRef = useRef(null);
  const batchPollRef = useRef(null);
  const [open, setOpen] = useState({ open: false, type: null });
  const [intervalId, setIntervalId] = useState(null);
  const [file, setFile] = useState(null);
  const [isLogicApplied, setIsLogicApplied] = useState("0");
  const [statusModalopen, setStatusModalOpen] = useState({
    open: false,
    statustext: "",
  });
  const [loading, setLoading] = useState(false);
  const { courseList } = useSelector((state) => state.masterReducer);
  const [id, setId] = useState(0);
  const [withVenue, setWithVenue] = useState(false);
  // Hall ticket re-release date (YYYY-MM-DD, date only) — printed on without-venue cards
  const [rereleaseDate, setRereleaseDate] = useState("");
  const todayStr = new Date().toLocaleDateString("en-CA"); // local YYYY-MM-DD

  // Without venue needs the re-release date; shows the alert and returns false if missing
  const checkRereleaseDate = () => {
    if (withVenue || rereleaseDate) return true;
    dispatch({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: "Please select the Hall Ticket Re-release Date for admit card without venue",
      },
    });
    return false;
  };
  const [singleSearchValue, setSingleSearchValue] = useState("");
  const { coursecandidatelist } = useSelector((state) => state.masterReducer);
  const { Admitcardbatchstatus } = useSelector((state) => state.generateAdmitcardReducer);

  const isBatchPending = Admitcardbatchstatus?.status === "PENDING";
  const isBatchProcessing = Admitcardbatchstatus?.status === "PROCESSING";
  const isBatchInProgress = isBatchPending || isBatchProcessing;

  console.log("Admitcardbatchstatus", Admitcardbatchstatus);
  // const admitCardGeneratedCount = coursecandidatelist?.reduce(
  //   (count, candidate) =>
  //     candidate.isadmitcardgenerated === "1" ? count + 1 : count,
  //   0
  // );
  const admitCardGeneratedCount = coursecandidatelist?.reduce(
    (count, candidate) =>
      candidate.rollno != null && candidate.isadmitcardgenerated === "1"
        ? count + 1
        : count,
    0
  );
  const admitCardNotGeneratedCount = coursecandidatelist?.reduce(
    (count, candidate) =>
      candidate.rollno != null && candidate.isadmitcardgenerated === "0"
        ? count + 1
        : count,
    0
  );
  const fixAdmitCardUrl = (url) => {
    const base = url.split('.pdf')[0];
    return `${base}.pdf`;
  };

//   const handleDownloadZip = async () => {
//     if (coursecandidatelist.length === 0) return alert('No candidates found!');
//     setLoading(true);

//     const zip = new JSZip();

//     // for (const candidate of coursecandidatelist) {
//     //   const fixedUrl = fixAdmitCardUrl(candidate.admitcardurl);
//     //   const fileName = `${candidate.candidatename}_${candidate.rollno}.pdf`;

//     //   try {
//     //     const response = await axios.get(fixedUrl, { responseType: 'blob' });
//     //     zip.file(fileName, response.data);
//     //   } catch (error) {
//     //     console.error(`Failed to download ${fileName}:`, error);
//     //   }
//     // }
// for (const candidate of coursecandidatelist) {
//   const fixedUrl = fixAdmitCardUrl(candidate.admitcardurl);
//   const fileName = `${candidate.candidatename}_${candidate.rollno}.pdf`;

//   try {
//     const response = await axios.get(fixedUrl, { responseType: 'blob' });

//     const contentType = response.headers['content-type'];
//     if (contentType !== 'application/pdf') {
//       console.warn(`Skipping ${fileName}: not a PDF (got ${contentType})`);
//       continue;
//     }

//     zip.file(fileName, response.data);
//   } catch (error) {
//     console.error(`Failed to download ${fileName}:`, error);
//   }
// }

//     zip.generateAsync({ type: 'blob' }).then((blob) => {
//       saveAs(blob, 'AdmitCards.zip');
//       setLoading(false);
//     });
//   };
const handleDownloadZip = async () => {
  dispatch({
    type: generateAdmitcardActions.GET_INTERNAL_ZIPFILE,
    payload: {
      courseid: id,
    },
  });
  // if (!coursecandidatelist.length) return;

  // setLoading(true);
  // const zip = new JSZip();

  // for (const candidate of coursecandidatelist) {
  //   const fileUrl = candidate.admitcardurl; // ✅ use full URL as-is
  //   const fileName = `${candidate.candidatename}_${candidate.rollno}.pdf`;

  //   try {
  //     const response = await fetch(fileUrl);
  //     if (!response.ok) {
  //       console.warn(`Skipping ${fileName}: HTTP ${response.status}`);
  //       continue;
  //     }

  //     const blob = await response.blob();
  //     zip.file(fileName, blob);
  //   } catch (error) {
  //     console.error(`Failed to fetch ${fileName}:`, error);
  //   }
  // }

  // zip.generateAsync({ type: 'blob' }).then((content) => {
  //   saveAs(content, 'AdmitCards.zip');
  //   setLoading(false);
  // });
};

  useEffect(() => {
    setFile(null);
    dispatch({
      type: masterActions.GET_COURSE_CANDIDATE_LIST,
      payload: {
        courseid: id,
        candidateid: 0,
      },
    });
  }, [isLogicApplied]);
  const toggleOpen = (type) => {
    setOpen({
      open: !open.open,
      type: type,
    });
  };
  const handleLogicAppliedChange = (e) => {
    setIsLogicApplied(e.target.value);
  };
  const handleDocumentUpload = (e) => {
    const file = e.target.files[0] || e.dataTransfer.files[0];
    setFile(file);
  };
  const handleUploadTemplate = () => {
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy"; // Show the copy cursor when dragging
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleDocumentUpload(e);
  };
  const handleUploadCandidateData = () => {
    dispatch({
      type: generateAdmitcardActions.GENERATE_ADMIT_CARD,
      payload: {
        courseid: id,
        getDataInterval: getDataInterval,
        setIntervalId: setIntervalId,
        setStatusModalOpen: setStatusModalOpen,
        file: file,
      },
    });
    // if (courseId && file) {
    //   dispatch({
    //     type: scorecardActions.UPLOAD_CANDIDATE_DATA,
    //     payload: {
    //       courseid: courseId,
    //       id: backofficeTokenDetails?.id,
    //       isExternalData: isExternalData,
    //       file,
    //       setOpen,
    //       setLoading,
    //       getDataInterval: getDataInterval,
    //       setIntervalId: setIntervalId,
    //       setStatusModalOpen: setStatusModalOpen,
    //       setFile,
    //     },
    //   });
    // }
  };
  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
    return () => stopBatchPolling();
  }, [dispatch]);

  useEffect(() => {
    const terminalStatuses = ["COMPLETED"];
    if (terminalStatuses.includes(Admitcardbatchstatus?.status)) {
      stopBatchPolling();
      return;
    }
    // a batch left in PENDING/PROCESSING (eg. picked up on course change or on
    // page reload) keeps refreshing until it reaches a terminal status
    if (isBatchInProgress && id > 0 && !batchPollRef.current) {
      startBatchPolling(id);
    }
  }, [Admitcardbatchstatus?.status, id]);
  const handleChange = (event) => {
    setId(event.target.value);
    setRereleaseDate(""); // the date is per course
    dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });
    dispatch({ type: masterActions.SET_COURSE_CANDIDATE_LIST, payload: [] });

    // reset any polling/status of the previously selected course and fetch the
    // latest batch status so a still pending request is visible immediately
    stopBatchPolling();
    dispatch({
      type: generateAdmitcardActions.SET_ADMIT_CARD_BATCH_STATUS,
      payload: null,
    });
    if (event.target.value) {
      dispatch({
        type: generateAdmitcardActions.GET_ADMIT_CARD_BATCH_STATUS,
        payload: { courseid: event.target.value },
      });
    }

    dispatch({
      type: masterActions.GET_COURSE_CANDIDATE_LIST,
      payload: {
        courseid: event.target.value,
        candidateid: 0,
      },
    });
    dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
  };

  let data = [
    {
      sheet: "Admitcard Generation Template",
      columns: [{ label: "rollno" }],
      content: [],
    },
  ];

  let settings = {
    fileName: "Admitcard Generation template",
    extraLength: 3,
    writeMode: "writeFile",
    writeOptions: {},
    RTL: false,
  };

  let callback = function (sheet) {
  };

  let getDataInterval = (logid) => {
    let intervalId = setInterval(() => {
      socketRef?.current?.emit("listenadmitcardstatus", { logid });
    }, 1000);
    return intervalId;
  };

  useEffect(() => {
    socketRef.current = io(
      `${API_URL}`,
      NODE_ENV === "production" && {
        path: "/api/socket.io",
        //     transports: ['websocket', 'polling'],
        // reconnection: true,
        // reconnectionAttempts: 5,
        // reconnectionDelay: 1000
      }
    );
    return () => (socketRef.current = null);
  }, []);

  useEffect(() => {
    socketRef?.current?.on("listengetadmitcardmessage", (message) => {
      // let data = message?.data
      if (message?.statusCode === 200) {
        let statustext = message?.data?.trim();
        if (
          statustext !=
          "Failed to generate admitcard.You can continue this process after allocating venue and generating roll number"
        ) {
          if (statustext?.toLowerCase() !== "completed") {
            setStatusModalOpen({
              open: true,
              statustext:
                statustext?.trim() !== "" && statustext !== null
                  ? statustext
                  : statusModalopen.statustext,
            });
          } else {
            setStatusModalOpen({
              open: false,
              statustext:
                statustext?.toLowerCase() !== "completed"
                  ? ""
                  : statusModalopen.statustext,
            });

            clearInterval(intervalId);
            dispatch({
              type: commonActions.SET_ALERT,
              payload: {
                status: "success",
                show: true,
                message: "Admitcard Generated successfully",
              },
            });
            dispatch({
              type: masterActions.GET_COURSE_CANDIDATE_LIST,
              payload: {
                courseid: id,
                candidateid: 0,
              },
            });
            setTimeout(function () {
              dispatch({
                type: commonActions.SET_ALERT,
                payload: {
                  status: "success",
                  show: false,
                  message: null,
                },
              });
            }, 2000);
            setOpen({
              open: false,
              type: "candidate",
            });
          }
        } else {
          clearInterval(intervalId);
          dispatch({
            type: commonActions.SET_ALERT,
            payload: {
              status: "failed",
              show: true,
              message:
                statustext ==
                "Failed to generate admitcard.You can continue this process after allocating venue and generating roll number"
                  ? "Failed to generate admitcard.You can continue this process after allocating venue and generating roll number"
                  : "Failed",
            },
          });
          dispatch({
            type: masterActions.GET_COURSE_CANDIDATE_LIST,
            payload: {
              courseid: id,
              candidateid: 0,
            },
          });
          setTimeout(function () {
            dispatch({
              type: commonActions.SET_ALERT,
              payload: {
                status: "failed",
                show: false,
                message: null,
              },
            });
          }, 2000);
          setStatusModalOpen({
            open: false,
            statustext: "",
          });
        }
      }
    });
    return () => socketRef?.current?.off("listenmessage");
  }, [dispatch, intervalId, socketRef]);

  const stopBatchPolling = () => {
    if (batchPollRef.current) {
      clearInterval(batchPollRef.current);
      batchPollRef.current = null;
    }
  };

  const startBatchPolling = (courseid) => {
    stopBatchPolling();
    dispatch({
      type: generateAdmitcardActions.GET_ADMIT_CARD_BATCH_STATUS,
      payload: { courseid },
    });
    batchPollRef.current = setInterval(() => {
      dispatch({
        type: generateAdmitcardActions.GET_ADMIT_CARD_BATCH_STATUS,
        payload: { courseid },
      });
    }, 3000);
  };

  const GenerateAdmitCard = () => {
    if (isBatchInProgress) {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: `Last request is in ${Admitcardbatchstatus?.status?.toLowerCase()}. Please wait till it completes.`,
        },
      });
      return;
    }
    if (!checkRereleaseDate()) return;
    dispatch({
      type: generateAdmitcardActions.GENERATE_ADMIT_CARD,
      payload: {
        courseid: id,
        withVenue: withVenue,
        ...(withVenue ? {} : { rereleaseDate }),
      },
    });
    startBatchPolling(id);
  };

  // One-off generation for a single candidate. Renders through the same worker
  // and the same admit-card code path the bulk batch uses; the card is stored
  // and recorded exactly as the batch stores it, then downloaded here.
  const GenerateSingleAdmitCard = () => {
    if (!id) return;
    if (!singleSearchValue?.trim()) {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: "Please enter an Application Number",
        },
      });
      return;
    }
    if (!checkRereleaseDate()) return;
    dispatch({
      type: singleAdmitcardActions.GENERATE_SINGLE_ADMITCARD,
      payload: {
        courseid: id,
        searchvalue: singleSearchValue.trim(),
        withVenue: withVenue,
        ...(withVenue ? {} : { rereleaseDate }),
        onSuccess: () => setSingleSearchValue(""),
      },
    });
  };

  const GetAdmitCardBatchStatus = () => {
    dispatch({
      type: generateAdmitcardActions.GET_ADMIT_CARD_BATCH_STATUS,
      payload: {
        courseid: id,
      },
    });
  };

  const handleReset = () => {
    dispatch({
      type: generateAdmitcardActions.DELETE_ADMIT_CARD,
      payload: { courseid: id },
    });
    dispatch({
      type: masterActions.GET_COURSE_CANDIDATE_LIST,
      payload: {
        courseid: id,
        candidateid: 0,
      },
    });
  };

  return (
    <div>
      <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
        <CardContent sx={{ p: 3 }}>
          <Stack spacing={2.5}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                rowGap: 2,
                columnGap: 2,
              }}
            >
              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel
                  id="course-select-label"
                  sx={{ fontSize: "14px" }}
                >
                  Course
                </InputLabel>
                <Select
                  labelId="course-select-label"
                  label="Course"
                  value={id}
                  onChange={handleChange}
                  sx={{
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <MenuItem value={0} sx={{ fontSize: "14px" }}>
                    Select Course
                  </MenuItem>
                  {courseList?.all?.map((course, i) => (
                    <MenuItem
                      key={i}
                      value={course?.courseid}
                      sx={{ fontSize: "14px", whiteSpace: "nowrap" }}
                    >
                      {course?.coursename}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ minWidth: 170 }}>
                <InputLabel id="venue-select-label" sx={{ fontSize: "14px" }}>
                  Venue
                </InputLabel>
                <Select
                  labelId="venue-select-label"
                  label="Venue"
                  value={withVenue}
                  onChange={(e) => setWithVenue(e.target.value)}
                  sx={{
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <MenuItem value={true} sx={{ fontSize: "14px" }}>
                    With Venue
                  </MenuItem>
                  <MenuItem value={false} sx={{ fontSize: "14px" }}>
                    Without Venue
                  </MenuItem>
                </Select>
              </FormControl>

              {!withVenue && (
                <TextField
                  size="small"
                  type="date"
                  required
                  label="Hall Ticket Re-release Date"
                  value={rereleaseDate}
                  onChange={(e) => setRereleaseDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ min: todayStr }}
                  sx={{ minWidth: 210, "& .MuiInputBase-input": { fontSize: "14px" } }}
                />
              )}

              <Box sx={{ flexGrow: 1 }} />

              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: 1.5,
                }}
              >
                <BluePrimaryButton
                  title={"Generate AdmitCard"}
                  handleSubmit={GenerateAdmitCard}
                  // disabled={
                  //   id == 0 ||
                  //   coursecandidatelist?.length == 0 ||
                  //   coursecandidatelist?.[0]?.templatedocs == null ||
                  //   coursecandidatelist?.[0]?.isadmitcardgenerated == 1 ||
                  //   isLogicApplied == 1
                  // }
                  disabled={
                    id == 0 || isBatchInProgress
                  }
                />
                <BluePrimaryButton
                  title={"Reset"}
                  handleSubmit={handleReset}
                  disabled={
                    id == 0 ||
                    coursecandidatelist?.length == 0 ||
                    coursecandidatelist?.[0]?.isadmitcardgenerated == 0 ||
                    coursecandidatelist?.[0]?.templatedocs == null
                  }
                />
                <MauvelousPrimaryButton
                  handleClick={() => xlsx(data, settings, callback)}
                  title="Download Template"
                  disabled={!id || isLogicApplied == 0}
                />
                {/* <MauvelousPrimaryButton
                  handleClick={() => {
                    if (id) {
                      toggleOpen("candidate");
                    }
                  }}
                  disabled={!id || isLogicApplied == 0}
                  title=" Upload Rollno Data"
                ></MauvelousPrimaryButton> */}
                <MauvelousPrimaryButton
                  handleClick={handleDownloadZip}
                  disabled={!id || coursecandidatelist?.length == 0}
                  title=" Download Admit Cards ZIP"
                ></MauvelousPrimaryButton>
              </Box>
            </Box>

            {isBatchInProgress && (
              <Alert severity="info" sx={{ fontSize: "13px", py: 0.5 }}>
                {isBatchPending
                  ? "Last request is in pending. Please wait till the previous admit card batch is completed."
                  : "Last request is in processing. Please wait till the previous admit card batch is completed."}
                {Admitcardbatchstatus?.totalCount != null &&
                  ` (${Admitcardbatchstatus?.processed ?? 0}/${Admitcardbatchstatus?.totalCount} processed)`}
              </Alert>
            )}
            <Divider />
            <Box>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                fontSize="13px"
                sx={{ mb: 1 }}
              >
                Generate Single Admit Card
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: 1.5,
                }}
              >
                <TextField
                  size="small"
                  label="Application No."
                  value={singleSearchValue}
                  onChange={(e) => setSingleSearchValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") GenerateSingleAdmitCard();
                  }}
                  disabled={id == 0}
                  sx={{
                    minWidth: 260,
                    "& .MuiInputBase-input": { fontSize: "14px" },
                    "& .MuiInputLabel-root": { fontSize: "14px" },
                  }}
                />
                <BluePrimaryButton
                  title={"Generate & Download"}
                  handleSubmit={GenerateSingleAdmitCard}
                  disabled={id == 0 || !singleSearchValue?.trim()}
                />
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "12px" }}
                >
                  Uses the Course and Venue option selected above.
                </Typography>
              </Box>
            </Box>

            <Divider />

            <Box>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                fontSize="13px"
                sx={{ mb: 0.5 }}
              >
                Generation Mode
              </Typography>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={isLogicApplied}
                onChange={handleLogicAppliedChange}
                row
              >
                <FormControlLabel
                  value="1"
                  control={<Radio size="small" />}
                  label="Partial Generation"
                  sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px" } }}
                />
                <FormControlLabel
                  value="0"
                  control={<Radio size="small" />}
                  label="Whole Generation"
                  sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px" } }}
                />
              </RadioGroup>
            </Box>
          </Stack>
        </CardContent>
      </Card>

      {id > 0 && (
        <>
          {coursecandidatelist?.length > 0 && (
            <TableContainer>
              <Table style={{ marginTop: "3px" }}>
                <TableBody>
                  <TableRow>
                    <TableCell style={{ border: "1px solid black" }}>
                      Total candidates for this course
                    </TableCell>
                    <TableCell style={{ border: "1px solid black" }}>
                      {coursecandidatelist?.length}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ border: "1px solid black" }}>
                      Admit cards already generated
                    </TableCell>
                    <TableCell style={{ border: "1px solid black" }}>
                      {admitCardGeneratedCount}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ border: "1px solid black" }}>
                      Yet to generate admit cards
                    </TableCell>
                    <TableCell style={{ border: "1px solid black" }}>
                      {" "}
                      {admitCardNotGeneratedCount}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </>
      )}

      {Admitcardbatchstatus && (
        <Box mt={3}>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography variant="subtitle1" fontWeight={600}>
              Batch Generation Status
            </Typography>
            <Chip
              label={Admitcardbatchstatus.status}
              size="small"
              color={
                Admitcardbatchstatus.status === "COMPLETED"
                  ? "success"
                  : Admitcardbatchstatus.status === "FAILED"
                  ? "error"
                  : Admitcardbatchstatus.status === "PARTIAL_FAILED"
                  ? "warning"
                  : Admitcardbatchstatus.status === "PROCESSING"
                  ? "info"
                  : Admitcardbatchstatus.status === "PENDING"
                  ? "warning"
                  : "default"
              }
            />
          </Box>

          <Grid container spacing={2}>
            {[
              { label: "Total", value: Admitcardbatchstatus.totalCount, color: "#1976d2" },
              { label: "Processed", value: Admitcardbatchstatus.processed, color: "#2e7d32" },
              { label: "Pending", value: Admitcardbatchstatus.pending, color: "#ed6c02" },
              { label: "Failed", value: Admitcardbatchstatus.failedCount, color: "#d32f2f" },
            ].map(({ label, value, color }) => (
              <Grid item xs={6} sm={3} key={label}>
                <Card variant="outlined" sx={{ borderLeft: `4px solid ${color}` }}>
                  <CardContent sx={{ py: 1.5, "&:last-child": { pb: 1.5 } }}>
                    <Typography variant="caption" color="text.secondary">
                      {label}
                    </Typography>
                    <Typography variant="h5" fontWeight={700} color={color}>
                      {value ?? 0}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Box mt={2}>
            <Box display="flex" justifyContent="space-between" mb={0.5}>
              <Typography variant="caption" color="text.secondary">
                Progress
              </Typography>
              <Typography variant="caption" fontWeight={600}>
                {Admitcardbatchstatus.progressPercent ?? 0}%
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={Admitcardbatchstatus.progressPercent ?? 0}
              sx={{ height: 8, borderRadius: 4 }}
              color={
                Admitcardbatchstatus.status === "COMPLETED"
                  ? "success"
                  : Admitcardbatchstatus.status === "FAILED"
                  ? "error"
                  : Admitcardbatchstatus.status === "PARTIAL_FAILED"
                  ? "warning"
                  : "primary"
              }
            />
            {Admitcardbatchstatus.lastUpdated && (
              <Typography variant="caption" color="text.secondary" display="block" mt={0.5}>
                Last updated: {new Date(Admitcardbatchstatus.lastUpdated).toLocaleString()}
              </Typography>
            )}
          </Box>
        </Box>
      )}
      <Modal
        open={open.open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
          }}
        >
          {file ? (
            <Box
              pl={2}
              style={{
                width: "fit-content",
                // maxWidth: "18em",
                height: "45px",
                border: "1px solid #D5D5D5",
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                marginTop: "1rem",
                paddingLeft: "0",
                // overflow: "hidden",
                // whiteSpace: "nowrap",
                // position: 'relative'
              }}
            >
              <img
                src={xlsxpng}
                style={{ height: "auto", width: "30px", marginLeft: "5px" }}
                alt="xlsx"
              />
              <Box sx={{ paddingLeft: "10px" }}>{file?.name}</Box>
              <Box
                onClick={() => setFile(null)}
                sx={{ paddingRight: "10px", cursor: "pointer" }}
                //  sx={{position: 'absolute', right: 0, width: '1.5rem', paddingLeft: '5px', backgroundColor: `${cssProperties?.backgroundcolor?.secondary}`}}
              >
                <PiXBold />
              </Box>
            </Box>
          ) : (
            <Box
              style={{
                border: "1px dashed gray",
                maxWidth: "330px",
                minHeight: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 340,
                position: "relative",
              }}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              <input
                type="file"
                name="document"
                id="document"
                accept=".xlsx"
                alt=""
                style={{
                  width: "0.1px",
                  height: "0.1px",
                  opacity: 0,
                  overflow: "hidden",
                  position: "absolute",
                  zIndex: -1,
                }}
                onChange={handleDocumentUpload}
              />

              <label
                htmlFor="document"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IoCloudUploadOutline style={{ marginLeft: "8px" }} size={22} />{" "}
                <span>
                  {" "}
                  &nbsp; Drag or drop your file, or{" "}
                  <span style={{ color: "blue" }}>&nbsp;browse</span>
                </span>
                <small style={{ color: "rgb(102, 102, 102)" }}>
                  (xlsx) (5mb max.)
                </small>
              </label>
            </Box>
          )}
          <Box
            mt={2}
            justifyContent="end"
            alignItems="center"
            display="flex"
            gap={1}
          >
            <BluePrimaryButton
              disabled={loading}
              handleSubmit={() => {
                toggleOpen();
                setFile(null);
              }}
              title="Close"
            />
            <MauvelousPrimaryButton
              disabled={loading || !file || id === 0}
              handleClick={
                open.type === "candidate"
                  ? handleUploadCandidateData
                  : handleUploadTemplate
              }
              title="Submit"
            />
          </Box>
        </Box>
      </Modal>
      <Modal
        open={statusModalopen.open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            height: 200,
          }}
        >
          <Box my={2}>
            <CircularProgress
              sx={{ color: `${cssProperties?.color?.primary}` }}
              size={50}
              thickness={2}
            />
          </Box>
          {statusModalopen.statustext}
        </Box>
      </Modal>
    </div>
  );
}
